import CurrentPolicyDetails from "./currentPolicyDetails"

// eslint-disable-next-line import/no-cycle
export { config } from "./_config"

export default CurrentPolicyDetails
